import { supabase, isSupabaseConfigured } from "../lib/supabaseClient";
import { signatureCases as staticSignatureCases } from "../content/signatureCases";

const TABLE_NAME = "signature_cases";

const mapRecord = (record) => ({
  id: record.id,
  slug: record.slug,
  label: record.label,
  title: record.title,
  intro: record.intro,
  meta: record.meta ?? [],
  body: record.body ?? [],
  timeline: record.timeline ?? [],
  gallery: record.gallery ?? [],
  ctaLabel: record.cta_label ?? record.ctaLabel ?? "Detaylı case talep et",
  ctaUrl: record.cta_url ?? record.ctaUrl ?? "mailto:studio@modelerman.com",
  orderIndex: record.order_index ?? record.orderIndex ?? 0,
  published: record.published ?? true,
});

export const fetchSignatureCases = async () => {
  if (!isSupabaseConfigured || !supabase) {
    return staticSignatureCases.map((item, index) => ({ ...item, orderIndex: index }));
  }

  const { data, error } = await supabase
    .from(TABLE_NAME)
    .select("id, slug, label, title, intro, meta, body, timeline, gallery, cta_label, cta_url, order_index, published")
    .order("order_index", { ascending: true });

  if (error) {
    console.error("Supabase fetchSignatureCases error", error);
    throw error;
  }

  return (data ?? []).map(mapRecord);
};

const toSupabaseRecord = (record, index = 0) => ({
  id: record.id,
  slug: record.slug,
  label: record.label,
  title: record.title,
  intro: record.intro,
  meta: record.meta ?? [],
  body: record.body ?? [],
  timeline: record.timeline ?? [],
  gallery: record.gallery ?? [],
  cta_label: record.ctaLabel ?? record.cta_label ?? "Detaylı case talep et",
  cta_url: record.ctaUrl ?? record.cta_url ?? "mailto:studio@modelerman.com",
  order_index: record.orderIndex ?? record.order_index ?? index,
  published: record.published ?? true,
});

export const upsertSignatureCase = async (payload) => {
  if (!isSupabaseConfigured || !supabase) {
    throw new Error("Supabase yapılandırılmadan kayıt güncellenemez. Lütfen .env içinde REACT_APP_SUPABASE_URL ve REACT_APP_SUPABASE_ANON_KEY değerlerini tanımlayın.");
  }

  const { data, error } = await supabase
    .from(TABLE_NAME)
    .upsert(toSupabaseRecord(payload, payload.orderIndex))
    .select()
    .single();

  if (error) {
    console.error("Supabase upsertSignatureCase error", error);
    throw error;
  }

  return mapRecord(data);
};

export const deleteSignatureCase = async (id) => {
  if (!isSupabaseConfigured || !supabase) {
    throw new Error("Supabase yapılandırılmadan kayıt silinemez.");
  }

  const { error } = await supabase.from(TABLE_NAME).delete().eq("id", id);

  if (error) {
    console.error("Supabase deleteSignatureCase error", error);
    throw error;
  }

  return true;
};

export const reorderSignatureCases = async (orderedIds) => {
  if (!isSupabaseConfigured || !supabase) {
    throw new Error("Supabase yapılandırılmadan sıralama güncellenemez.");
  }

  const updates = orderedIds.map((id, index) => ({ id, order_index: index }));
  const { error } = await supabase.from(TABLE_NAME).upsert(updates);

  if (error) {
    console.error("Supabase reorderSignatureCases error", error);
    throw error;
  }

  return true;
};

export const seedSignatureCases = async () => {
  if (!isSupabaseConfigured || !supabase) {
    throw new Error("Supabase yapılandırması yapılmadan veri yüklenemez.");
  }

  const payload = staticSignatureCases.map((item, index) => toSupabaseRecord({ ...item, orderIndex: index }, index));

  const { data, error } = await supabase
    .from(TABLE_NAME)
    .upsert(payload, { onConflict: "id" })
    .select();

  if (error) {
    console.error("Supabase seedSignatureCases error", error);
    throw error;
  }

  return (data ?? payload).map(mapRecord).sort((a, b) => (a.orderIndex ?? 0) - (b.orderIndex ?? 0));
};
